import { z } from 'zod';
import { passwordSchema } from '../auth/schemas.js';
export const createUserSchema = z.object({
    name: z.string().trim().min(2).max(120),
    email: z.string().trim().toLowerCase().pipe(z.email()),
    password: passwordSchema,
    roleKeys: z.array(z.string().min(2)).min(1),
});
//# sourceMappingURL=admin.js.map